class AuthHelper {
  static KEY = 'authToken';

  static setToken(authToken: string): void {
    localStorage.setItem(this.KEY, authToken);
  }

  static getToken(): string {
    return localStorage.getItem(this.KEY) || '';
  }

  static removeToken(): void {
    localStorage.removeItem(this.KEY);
  }
}

export default AuthHelper;
